const handleCopy = (element) => {
  if (element) {
   const { innerText } = element;
   console.log(element, innerText)
   navigator.clipboard.writeText(innerText).then(function() {
     /* clipboard successfully set */
     element.innerText = 'Copied / ተገልብጧል ...';
     setTimeout(() => {
       element.innerText = innerText;
     }, 3000);

   }, function() {
     /* clipboard write failed */
     element.innerText = 'There was an Error copying..';
     element.style.color = 'red';
     setTimeout(() => {
       element.innerText = innerText;
       element.style.color = 'initial';
     }, 3000);
   });
  }
}

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

  export default { handleCopy, getRandomInt };